module.exports = __webpack_public_path__ + "static/img/gd.f416170.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/zh/gd.png
// module id = mQpc
// module chunks = 1